/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportScheduleDto } from './reportScheduleDto';


export interface ReportScheduleDtoPagedResultDto { 
    items?: Array<ReportScheduleDto> | null;
    totalCount?: number;
}

